import { Divider } from "primereact/divider";
import { useTranslation } from 'react-i18next';
export default function ScansCard(props) {
  const { name, time, imageSrc, bgColor, patients, key, index } = props;
  const{t}=useTranslation();
  return (t,
    <>   
      <div
        className="top-0 left-0 text-left absolute w-full rounded-t pl-2 font-bold"
        style={{ background: bgColor,color:"black" }}
      >{name}</div>
      <img
        src={imageSrc}
        alt={name}
        style={{ width: 35, height: '100%', borderRadius: 50 ,marginTop:"15px"}}
      />
      <div className="flex flex-row align-items-center">
        <div className="flex flex-column w-[80px]">
          <span className="text-bold text-sm" style={{marginTop:"20px"}}>{t("TOTAL_PATIENTS")}</span>
          <div>{patients}</div>
        </div>
        <Divider style={{marginTop:"24px"}}layout="vertical" />
        <div className="flex flex-column w-[80px]">
          <div className="text-bold text-sm"style={{marginTop:"20px",marginLeft:"20px"}}>{t("TOTAL_AVERAGE_TIME")}</div>
          <div className="flex align-items-center gap-2" style={{marginLeft:"20px",marginTop:"5px"}}><i className="pi pi-clock"/>{time}</div>
        </div>
      </div>
    </>
  );
}
